import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-68126c73"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "dt-input" };
const _hoisted_2 = { class: "dt-input__label" };
const _hoisted_3 = { class: "dt-input__inner" };
const _hoisted_4 = { class: "dt-input__inner-header" };
const _hoisted_5 = { class: "w-64" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Mo", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Tu", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "We", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Th", -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Fr", -1));
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Sa", -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "Su", -1));
const _hoisted_13 = ["onClickPassive"];
const _hoisted_14 = { key: 1 };
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/outline";
import moment from "moment";
import { computed, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        errors: null,
        label: null,
        modelValue: null
    },
    emits: ["update:modelValue"],
    setup(__props, { emit }) {
        const props = __props;
        const calDate = ref(moment.utc().toDate());
        const selDate = ref(props.modelValue);
        const bodySel = (day) => {
            selDate.value = day;
            emit("update:modelValue", day);
        };
        const bodyClass = (day) => {
            return [
                "date",
                moment.utc(day).isSame(selDate.value) ? "date--selected" : "",
                !moment.utc(day).isSame(calDate.value, "month") ? "date--not-current" : "",
            ].join(" ");
        };
        const getDays = () => {
            const start = moment.utc(calDate.value).startOf("month");
            const end = moment.utc(calDate.value).endOf("month");
            let date = start.clone();
            let acc = [];
            date = date.subtract(start.day() - 1, "days");
            for (let i = 0; i < 7 * 6; i++) {
                acc = [...acc, date.toDate()];
                date = date.clone().add(1, "days");
            }
            return acc;
        };
        const days = computed(getDays);
        const hasErrors = computed(() => (props.errors?.length ?? 0) > 0);
        const next = () => (calDate.value = moment.utc(calDate.value).add(1, "month").toDate());
        const prev = () => (calDate.value = moment.utc(calDate.value).subtract(1, "month").toDate());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.$slots['label'] || props.label.length)
                    ? _renderSlot(_ctx.$slots, "label", { key: 0 }, () => [
                        _createElementVNode("label", _hoisted_2, _toDisplayString(props?.label), 1)
                    ])
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(ChevronLeftIcon), {
                            onClickPassive: prev,
                            class: "icon"
                        }),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(moment).utc(calDate.value).format("MMMM YYYY")), 1),
                        _createVNode(_unref(ChevronRightIcon), {
                            onClickPassive: next,
                            class: "icon"
                        })
                    ]),
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), (day) => {
                        return (_openBlock(), _createElementBlock("a", {
                            onClickPassive: ($event) => (bodySel(day)),
                            class: _normalizeClass(bodyClass(day)),
                            key: _unref(moment).utc(day).format('YYYY-MM-DD')
                        }, _toDisplayString(_unref(moment).utc(day).format("DD")), 43, _hoisted_13));
                    }), 128))
                ]),
                (_unref(hasErrors))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(props.errors.join(" ")), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
